import React, { useEffect, useState } from "react";
import { db } from "../Admin/Config/Config";
import { doc, getDoc } from "firebase/firestore";
export default function Instruction({ instructions, onResult }) {
  const [isOpen, setIsOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [insrtuctions, setInstructions] = useState(false);
  const [availableTopics, setAvailableTopics] = useState([]);

  // ================== FETCH INSTRUCTIONS ================== //
  const fetchInstructions = async () => {
    const instructionsRef = doc(db, "bristu_talk_instruction", "instruction");
    const instructionsSnap = await getDoc(instructionsRef);
    if (instructionsSnap.exists()) {
      setInstructions(instructionsSnap.data());
      setAvailableTopics(instructionsSnap.data().topics);
    }
}

useEffect(() => {
  fetchInstructions();
}, []);



  useEffect(() => {
    setIsOpen(instructions);
  }, [instructions]);

  const handleStartSession = () => {
    if (checked) {
      onResult({status: true, topic: currentTopic});
      setIsOpen(false);
    }
  };

  const [currentTopic, setCurrentTopic] = useState(null);

  // ============= Pick a random topic when topics change ============ //
  useEffect(() => {
    if (availableTopics.length > 0) {
      setCurrentTopic(
        availableTopics[Math.floor(Math.random() * availableTopics.length)]
      );
    } else {
      setCurrentTopic(null);
    }
  }, [availableTopics]);

  // ================  Handle topic selection and Skip to a new topic ================= //
  const handleNextTopic = () => {
    if (availableTopics.length > 1) {
      let newTopic;
      do {
        newTopic =
          availableTopics[Math.floor(Math.random() * availableTopics.length)];
      } while (newTopic === currentTopic);
      setCurrentTopic(newTopic);
    }
  };
const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-2 sm:p-4 overflow-y-auto">
          <div className="bg-white backdrop-blur-xl rounded-2xl shadow-2xl w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl mx-4 my-8 p-4 sm:p-6 md:p-8 border border-white/20 transition-all duration-300 max-h-[90vh] overflow-y-auto">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
              Prepare for Your Session
              <span className="block w-8 sm:w-12 h-1 bg-gradient-to-r from-blue-500 to-emerald-500 mt-2 rounded-full" />
            </h2>

            <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
            <div className="space-y-3 sm:space-y-4">
  <h3 className="text-xs sm:text-sm font-semibold text-gray-500 uppercase tracking-wide">
    Requirements
  </h3>
  <ol className="list-decimal list-inside space-y-1 sm:space-y-2 text-sm sm:text-base">
    {(isExpanded ? insrtuctions?.instruction : insrtuctions?.instruction?.slice(0, 250) ?? "")
      .split('\n')
      .filter(line => line.trim() !== '')
      .map((point, index) => (
        <li key={index} className="text-gray-900">{point}</li>
      ))}
  </ol>
  {insrtuctions?.instruction?.length > 500 && (
    <button
      onClick={() => setIsExpanded(!isExpanded)}
      className="text-green-600 text-xs sm:text-sm"
    >
      {isExpanded ? 'Read less' : 'Read more...'}
    </button>
  )}
</div>

              <div className="space-y-3 sm:space-y-4">
                {currentTopic ? (
                  <div className="space-y-3 sm:space-y-4 border p-3 sm:p-4 rounded-xl">
                    <h2 className="text-base sm:text-lg font-bold text-center">
                      Your topic
                    </h2>
                    <button
                      className={`w-full py-2 sm:py-3 px-4 sm:px-6 rounded-xl flex items-center justify-between group transition-all duration-200 border-2 shadow-md 
                        bg-gradient-to-r from-green-600 to-emerald-700 hover:from-green-700 hover:to-emerald-600 border-green-400 shadow-lg
                      }`}
                    >
                      <span className="text-white font-medium text-xs sm:text-sm">
                        {currentTopic}
                      </span>
                     
                        <svg
                          className="w-4 h-4 sm:w-5 sm:h-5 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      
                    </button>
                    <button
                      onClick={handleNextTopic}
                      className="w-full py-2 sm:py-3 px-4 sm:px-6 rounded-xl bg-gray-900 hover:bg-gray-900 transition-colors duration-200 flex items-center justify-center space-x-2"
                    >
                      <span className="text-gray-100 font-medium text-xs sm:text-sm">
                        Next Topic
                      </span>
                      <svg
                        className="w-3 h-3 sm:w-4 sm:h-4 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </button>
                  </div>
                ) : (
                  <div className="p-3 sm:p-4 rounded-xl bg-green-500/10 border border-green-500/30 flex flex-col items-center space-y-2 shadow-md">
                    <svg
                      className="w-6 h-6 sm:w-8 sm:h-8 text-green-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <p className="text-green-500 font-medium text-center text-xs sm:text-sm">
                      Topic selected!
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="flex items-start space-x-3 mb-6 sm:mb-8">
              <button
                onClick={() => setChecked(!checked)}
                className={`shrink-0 w-4 h-4 sm:w-5 sm:h-5 rounded border flex items-center justify-center transition-colors duration-200 ${
                  checked
                    ? "bg-emerald-500 border-emerald-500"
                    : "bg-white border-gray-300"
                }`}
              >
                {checked && (
                  <svg
                    className="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 text-white animate-pop-in"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                )}
              </button>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                I agree to the terms of service and privacy policy, and confirm
                I'm ready for the audio session.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
              <button
                onClick={() => onResult({ status: false, topic: currentTopic })}
                className="px-4 sm:px-6 py-2 sm:py-3 bg-gray-200 rounded-xl text-gray-500 hover:bg-gray-50 transition-colors font-medium flex-1 text-xs sm:text-sm"
              >
                Cancel
              </button>
              <button
                onClick={handleStartSession}
                className={`px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-medium border flex-1 transition-all text-xs sm:text-sm ${
                  checked 
                    ? "bg-gradient-to-br from-emerald-500 to-emerald-500 text-white shadow-lg hover:shadow-xl hover:scale-[1.02]"
                    : "bg-gray-100 text-gray-900 cursor-not-allowed"
                }`}
              >
                Start Session
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
